<div class="shell">
  <!-- Brand gradient header -->
  <header class="shell__header">
    <a class="shell__brand" routerLink="/updates">
      <img class="shell__mark" src="Cover-Logo-512x512-blue.png" alt="Cover" />
      <span class="shell__title" i18n="@@header.title">Systray</span>
    </a>

    <div class="shell__header-right">
      <!-- 1. Entreprise -->
      <app-tenant-chip class="shell__tenant" />

      <!-- 2. User -->
      <div class="shell__user">
        <span class="shell__avatar">{{ initials() }}</span>
        <span class="shell__username">{{ username() }}</span>
      </div>

      <!-- 3. Utilitaires : mode nuit · langue · déconnexion -->
      <div class="shell__utils">
        <app-theme-toggle />

        <button
          class="shell__icbtn focus-ring"
          type="button"
          (click)="switchLanguage()"
          [title]="currentLang === 'fr' ? 'Switch to English' : 'Passer en francais'"
          [attr.aria-label]="currentLang === 'fr' ? 'Switch to English' : 'Passer en francais'"
        >
          @if (currentLang === 'fr') {
            <svg viewBox="0 0 3 2" class="shell__flag" aria-hidden="true">
              <rect width="3" height="2" fill="#fff" />
              <rect width="1" height="2" fill="#0055A4" />
              <rect x="2" width="1" height="2" fill="#EF4135" />
            </svg>
          } @else {
            <svg viewBox="0 0 60 30" class="shell__flag" aria-hidden="true">
              <clipPath id="ukclip"><rect width="60" height="30" /></clipPath>
              <g clip-path="url(#ukclip)">
                <rect width="60" height="30" fill="#012169" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" stroke-width="4" />
                <path d="M30,0 V30 M0,15 H60" stroke="#fff" stroke-width="10" />
                <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" stroke-width="6" />
              </g>
            </svg>
          }
        </button>

        <button
          class="shell__icbtn focus-ring"
          type="button"
          (click)="logout()"
          aria-label="Logout"
          i18n-aria-label="@@header.logout"
          title="Logout"
        >
          <app-icon name="power_settings_new" [size]="20" />
        </button>
      </div>
    </div>
  </header>

  <div class="shell__body">
    <aside class="shell__sidebar glass">
      <nav class="shell__nav">
        @for (item of visibleNav(); track item.path) {
          <a
            class="shell__navitem focus-ring"
            [routerLink]="item.path"
            [queryParams]="item.path === '/aide' && nouveautesNonLues() ? { onglet: 'nouveautes' } : {}"
            routerLinkActive="is-active"
          >
            <app-icon class="shell__navicon" [name]="item.icon" [size]="20" />
            <span>{{ item.label }}</span>
            <!-- odoo-5133 — pastille des nouveautés non lues. Un point, pas un compteur :
                 ce qui compte est « il y a du nouveau », pas combien. -->
            @if (item.path === '/aide' && nouveautesNonLues()) {
              <span
                class="shell__navdot"
                aria-label="Nouveautés non lues"
                i18n-aria-label="@@nav.unreadNews"
              ></span>
            }
          </a>
        }
      </nav>
    </aside>

    <main class="shell__main">
      <ng-content />
    </main>
  </div>
</div>
